import React from 'react';
import { ReactElementLike } from 'prop-types';

interface TopBlockErrorBoundaryProps {
  name: string;
  message: string;
  title: string;
  children: ReactElementLike;
}
interface TopBlockErrorBoundaryState {
  hasError: boolean;
}

export default class TopBlockErrorBoundary extends React.Component<TopBlockErrorBoundaryProps, TopBlockErrorBoundaryState> {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error(this.props.name, error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      const clearError = (event) => {
        event.preventDefault();
        this.setState({ hasError: false });
      };
      return (
        <div id="intro-articles" className="intro-segment section-part-third news-feed">
          <div className="media-feed-title page-title-box">
            <div className="media-feed-title-wrap page-title-box-inner content-bg">
              <div className="member-feed-header">
                <div className="member-feed-title">
                  <h3 className="feed-title">
                    <span className="aligner-middle" />
                    <span className="media-feed-title-part">{this.props.title}</span>
                  </h3>
                </div>
              </div>
            </div>
          </div>

          <div id="sxk-articles-slideshow" className="section-content">
            <div className="article-slide-image" />
            <div className="article-slide-content">
              <div className="article-slide-title-container">
                <h3 className="article-slide-title"></h3>
              </div>
              <div className="article-slide-created"></div>
              <div className="article-slide-text">{this.props.message}</div>
            </div>
          </div>
          <div className="article-slide-link">
            <a className="btn btn-default btn-feed" href="#" onClick={clearError}>
              Försök igen
            </a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
